import {useId} from 'react'

/**
 * The Uniap mark: a "U" on a coral-to-orange tile whose right arm stops short
 * of a yellow point — the path up, and the place it leads to.
 */
export function LogoMark({size = 28}: {size?: number}) {
  const id = useId()
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FA6404" />
          <stop offset="1" stopColor="#E2725B" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill={`url(#${id})`} />
      <path
        d="M10 9v8.5a6 6 0 0 0 12 0V14"
        fill="none"
        stroke="#fff"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <circle cx="22" cy="8.5" r="2.6" fill="#FFDD44" />
    </svg>
  )
}

/** Mark plus wordmark. The text inherits colour and font from the parent. */
export function Logo({size = 28, label = 'Uniap'}: {size?: number; label?: string}) {
  return (
    <span style={{display: 'inline-flex', alignItems: 'center', gap: Math.round(size * 0.32)}}>
      <LogoMark size={size} />
      <span>{label}</span>
    </span>
  )
}
